import React from 'react';
import { CodeActivationStep as CodeActivationStepForm } from '@fiverr-private/code_activation';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { useStepsContext } from '../StepsContext';
import { globalBigQueryReporter, globalMixpanelReporter } from '../../events';

export const CodeActivationStep = () => {
    const { goToStep } = useStepsContext();
    const { email, finishSigningFlowAndNavigate } = useIdentificationContext();

    return (
        <CodeActivationStepForm
            email={email}
            onSkip={finishSigningFlowAndNavigate}
            onSuccess={finishSigningFlowAndNavigate}
            onGoToChangeEmail={() => goToStep('change_email')}
            mixpanelEnrichment={globalMixpanelReporter.enrichment as Record<string, string>}
            bigQueryEnrichment={globalBigQueryReporter.enrichment as Record<string, string>}
        />
    );
};
